import type { CityConfig } from "../city-template/types";

export const spokaneValleyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — WA Dept of Health Vital Records", href: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records", description: "Official Washington vital records office in Tumwater" },
    { label: "Marriage Licenses — Spokane County Auditor", href: "https://www.spokanecounty.org/", description: "Spokane County Auditor — marriage license issuance" },
    { label: "Divorce Records — Spokane County Clerk", href: "https://www.spokanecounty.org/", description: "Spokane County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of WA DOH for online vital record orders" },
  ],
  city: "Spokane Valley",
  state: "Washington",
  stateAbbr: "WA",
  slug: "spokane-valley",
  route: "/spokane-valley",
  title: "Emergency Passport Spokane Valley, WA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Spokane Valley, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Spokane Valley, Liberty Lake, Otis Orchards, and all eastern Spokane County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Spokane Valley, WA",
  heroSubtitle: "Spokane Valley travelers — from Liberty Lake tech professionals to Spokane Valley Mall shoppers to eastern Spokane County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of the Spokane Valley corridor and eastern Washington.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Spokane%20Valley%20Washington%20with%20the%20Spokane%20River%20winding%20through%20the%20valley%2C%20Centennial%20Trail%20along%20the%20riverbank%2C%20modern%20suburban%20commercial%20corridors%20with%20mountains%20in%20the%20distance%2C%20Mirabeau%20Point%20Park%20with%20green%20spaces%2C%20Liberty%20Lake%20visible%20in%20the%20eastern%20distance%2C%20warm%20golden%20afternoon%20sunlight%20over%20the%20valley%2C%20Pacific%20Northwest%20inland%20suburban%20landscape%20with%20evergreens%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=spokane-valley-hero-001&orientation=landscape",
  heroImageAlt: "Spokane Valley Washington with Spokane River and Centennial Trail",
  geoPosition: "47.6732;-117.2394",
  geoPlacename: "Spokane Valley, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 285 miles, 4.5 hours via I-90",
  },
  nearbyCitiesZips: [
    { name: "Spokane Valley", zips: "99206, 99212, 99214, 99216" },
    { name: "Liberty Lake", zips: "99019" },
    { name: "Otis Orchards", zips: "99027" },
    { name: "Greenacres", zips: "99016" },
    { name: "Veradale", zips: "99037" },
    { name: "Millwood", zips: "99212" },
    { name: "Spokane", zips: "99201, 99202, 99203, 99204, 99205, 99206, 99207, 99208, 99212, 99223" },
    { name: "Newman Lake", zips: "99025" },
    { name: "Cheney", zips: "99004" },
    { name: "Medical Lake", zips: "99022" },
    { name: "Airway Heights", zips: "99001" },
    { name: "Post Falls", zips: "83854, 83877" },
    { name: "Coeur d'Alene", zips: "83814, 83815, 83816" },
    { name: "Rathdrum", zips: "83858" },
    { name: "Hayden", zips: "83835" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — no 4.5-hour drive across the Cascades" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Spokane Valley Corridor", desc: "Serving Spokane Valley, Liberty Lake, and the Idaho border communities" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Spokane Valley or Liberty Lake location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Spokane, WA", route: "/spokane" },
    { name: "Emergency passport help in Seattle, WA", route: "/seattle" },
    { name: "Urgent passport services in Bellevue, WA", route: "/bellevue" },
    { name: "Washington passport services overview", route: "/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Spokane Valley, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — a 4.5-hour drive west via I-90. Spokane Valley residents can ship from any UPS or FedEx in the Spokane Valley corridor.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Spokane Valley, Liberty Lake, Otis Orchards, Greenacres, Veradale, Millwood, and all of eastern Spokane County and the Idaho Panhandle",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Spokane Valley and the eastern Spokane County corridor. From the Spokane Valley Mall and the industrial parks along East Sprague to the Centennial Trail and Mirabeau Point, from Liberty Lake to the Idaho state line — we serve all of Spokane Valley and the eastern Inland Empire.",
  nearbyCitiesIntro: "We serve Spokane Valley and all nearby communities including Liberty Lake, Otis Orchards, Greenacres, Veradale, Millwood, Newman Lake, and the Idaho communities of Post Falls, Coeur d'Alene, Rathdrum, and Hayden.",
  howItWorksIntro: "Most Spokane Valley travelers complete everything online and ship documents overnight. No need to drive 4.5 hours across the Cascades to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Spokane Valley is the second largest city in eastern Washington with significant travel demand from Spokane Valley's commercial corridor, Liberty Lake tech companies, and border-area families. Here are the most common passport mistakes we see from Spokane Valley travelers.",
  testimonialsIntro: "Spokane Valley travelers — from Liberty Lake professionals to eastern Spokane County families to Idaho border commuters — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Spokane Valley, WA? Here are the most common ones we hear from eastern Spokane County travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — courier handles the drive", "No long drive across the Cascades required", "Perfect for eastern Washington travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — courier handles the drive", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 285 miles to Seattle via I-90", "Full day commitment — difficult from Spokane Valley"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Spokane Valley travelers with immediate departure needs — as fast as 24 hours. Our couriers handle the Seattle agency delivery. Perfect for last-minute trips, family emergencies, and Liberty Lake business travel.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — courier handles the drive", "Eastern Washington and Idaho Panhandle support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Spokane Valley adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Spokane Valley address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Spokane Valley residents and families — including Liberty Lake professionals, new citizens, and eastern Spokane County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Spokane Valley residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Spokane Valley and eastern Spokane County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Spokane Valley and eastern Spokane County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Spokane Valley WA", description: "Urgent passport processing for Spokane Valley Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Spokane Valley WA", description: "Fast passport renewal for Spokane Valley Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Spokane Valley WA", description: "New passport application services for Spokane Valley Washington residents applying for their first passport." },
    { name: "Child Passport Spokane Valley WA", description: "Minor passport services for Spokane Valley Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mark H.",
      location: "Spokane Valley, WA",
      rating: 5,
      text: "Family trip to Hawaii with 8 days notice. Four passports — two adult renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Indiana and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jennifer D.",
      location: "Liberty Lake, WA",
      rating: 5,
      text: "Tech conference in London with 6 days notice and my passport had expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Sprague and the process was seamless.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David S.",
      location: "Spokane Valley, WA",
      rating: 5,
      text: "Business trip to Vancouver BC with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Not having to drive to Seattle from the Valley was incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Rachel B.",
      location: "Otis Orchards, WA",
      rating: 5,
      text: "Lost my passport two weeks before a trip to Mexico. Fast Passport Center replaced it in 4 days. As someone near the Idaho border, the courier service is absolutely essential.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "sv-1",
      name: "Spokane Valley Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11707 E Sprague Ave",
      city: "Spokane",
      state: "WA",
      zip: "99206",
      phone: "(509) 928-2301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Spokane Valley, near Sprague Avenue corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Spokane Valley acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Spokane Valley, Liberty Lake, and east Spokane County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "sv-2",
      name: "Liberty Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2205 N Madson Rd",
      city: "Liberty Lake",
      state: "WA",
      zip: "99019",
      phone: "(509) 255-6151",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Liberty Lake, approximately 8 miles east of Spokane Valley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Liberty Lake, Otis Orchards, and the Idaho border area. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "sv-3",
      name: "Spokane Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "904 W Riverside Ave",
      city: "Spokane",
      state: "WA",
      zip: "99201",
      phone: "(509) 624-2121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Spokane, approximately 8 miles west of Spokane Valley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility in downtown Spokane. Convenient for west Spokane Valley residents near the city line.",
      icon: "ri-mail-line",
    },
    {
      id: "sv-4",
      name: "South Hill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2623 E 29th Ave",
      city: "Spokane",
      state: "WA",
      zip: "99223",
      phone: "(509) 535-4472",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Hill Spokane, approximately 12 miles from central Spokane Valley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves south Spokane and south Spokane Valley residents. Good alternative for south-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "sv-5",
      name: "Spokane County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1026 W Broadway Ave",
      city: "Spokane",
      state: "WA",
      zip: "99201",
      phone: "(509) 477-2220",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Spokane County Courthouse — approximately 8 miles from Spokane Valley",
      website: "https://www.spokanecounty.org/",
      websiteLabel: "Spokane County",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 285 miles via I-90 to Seattle", fpc: "No — ship from Spokane Valley" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Eastern WA Advantage", agency: "No special consideration", fpc: "Yes — courier handles the Cascades trip" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
    { feature: "Total Time Commitment", agency: "Full day driving + waiting at agency", fpc: "10 minutes online + overnight shipping" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Spokane Valley professionals and families often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Sprague Avenue or at Spokane Valley Mall sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Spokane County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Spokane Valley Post Office appointments fill during summer and academic conference seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Seattle",
      description: "Many Spokane Valley residents attempt to drive to the Seattle passport agency in an emergency. The 4.5-hour drive across the Cascades each way means a full day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Winter travel to warm destinations peaks January–March — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Spokane Valley or eastern Spokane County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Spokane Valley, Liberty Lake, or the surrounding area." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — handling the 4.5-hour Cascades drive for you." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Spokane Valley address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Spokane Valley, WA?", a: "Fast Passport Center offers emergency passport processing in Spokane Valley, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — without you making the 4.5-hour drive across the Cascades." },
    { q: "Does Spokane Valley have its own passport agency?", a: "No — Spokane Valley does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 4.5 hours west via I-90). Fast Passport Center's courier service means Spokane Valley residents never need to make that drive." },
    { q: "Can I get an expedited passport in Liberty Lake or Otis Orchards?", a: "Absolutely. Fast Passport Center serves all of eastern Spokane County including Liberty Lake, Otis Orchards, Greenacres, Veradale, Millwood, and the Idaho border communities of Post Falls and Coeur d'Alene. Our service works the same way everywhere." },
    { q: "What airport do Spokane Valley travelers use for international flights?", a: "Spokane International Airport (GEG) is the primary airport — approximately 15 miles west of Spokane Valley via I-90. GEG offers direct flights to Seattle, Portland, Denver, Minneapolis, and seasonal destinations. Most international travel connects through Seattle-Tacoma (SEA), Denver (DEN), or Minneapolis (MSP)." },
    { q: "Can I use the Idaho passport agency from Spokane Valley?", a: "No — Idaho does not have a regional passport agency. The nearest facility for both eastern Washington and Idaho residents is the Seattle Passport Agency (4.5 hours west) or the Denver Passport Agency (14+ hours southeast). Fast Passport Center's courier service serves both agencies and always picks the fastest option." },
    { q: "How much does an expedited passport cost in Spokane Valley, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Spokane Valley?", a: "Walgreens, CVS, and Rite Aid stores throughout Spokane Valley offer passport photos. UPS Store and FedEx Office locations also provide them. Many locations on East Sprague Avenue and near Spokane Valley Mall offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Liberty Lake tech companies?", a: "Yes. Fast Passport Center serves all of eastern Spokane County including Liberty Lake professionals and their families. We understand corporate travel schedules and can accommodate urgent business travel. Our courier service is especially valuable for busy professionals who can't take a day off to drive to Seattle." },
  ],
  photoLocations: [
    { name: "Walgreens — Sprague Avenue", address: "15604 E Sprague Ave, Spokane Valley, WA 99037", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Rite Aid — Spokane Valley", address: "15220 E Sprague Ave, Spokane, WA 99216", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Spokane Valley", address: "13817 E Sprague Ave, Spokane Valley, WA 99216", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Spokane Valley", address: "15108 E Sprague Ave, Spokane Valley, WA 99037", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Spokane Valley", address: "11723 E Sprague Ave, Spokane, WA 99206", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended. Serves Spokane Valley and eastside communities.", featured: true },
    { name: "WA DOL — Spokane Downtown", address: "1026 W Broadway Ave, Spokane, WA 99201", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Alternative DOL office in downtown Spokane. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "GEG",
      name: "Spokane International Airport",
      distance: "15 miles west of Spokane Valley via I-90",
      address: "9000 W Airport Dr, Spokane, WA 99224",
      note: "Primary airport for Spokane Valley and the Inland Empire. Direct flights to Seattle, Portland, Denver, Minneapolis, and seasonal destinations. Most international travel connects through Seattle-Tacoma (SEA), Denver (DEN), or Minneapolis (MSP).",
      flightUrl: "https://www.spokaneairports.net/",
      flightLabel: "GEG Flight Info",
      featured: true,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "Approximately 4.5 hours west of Spokane Valley via I-90",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Major international hub for Spokane Valley travelers. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: false,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "Approximately 14 hours southeast of Spokane Valley via I-90",
      address: "8500 Pena Blvd, Denver, CO 80249",
      note: "Alternative hub for Spokane Valley travelers heading south and east. United Airlines hub with extensive domestic and international connections.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
  ],
};